<template>
    <!-- modal confirmar generico -->
    <confirm-dialog
        ref="confirmDialog"
        :title="title"
        :titleWidth="titleWidth"
        :titleTruncate="titleTruncate"
        :confirmLabel="confirmLabel"
        :btnConfirm="btnConfirm"
        :closeOnConfirm="closeOnConfirm"
        :cancelLabel="cancelLabel"
        :btnCancel="btnCancel"
        :closeOnCancel="closeOnCancel"
        :detail="detail"
        :show="mostrarModalConfirm"
        :width="width"
        :topBottomFixed="topBottomFixed"
        :centralizedContent="centralizedContent"
        :centralizedSingleBtn="centralizedSingleBtn"
        :switchComponent="switchComponent"
        :switchOption1="switchOption1"
        :switchOption2="switchOption2"
        :switchInput="switchInput"
        :sizeTitle="sizeTitle"
        :topLoader="topLoader"
        :removeDisplayFlexTitle="removeDisplayFlexTitle"
        :mensagemModalConfirm="mensagemModalConfirm"
        :metodoModalConfirm="metodoModalConfirm"
        :fecharModalConfirm="fecharModalConfirm"
        @onCancel="mostrarModalConfirm = false"
        @onConfirm="confirmar"
    >
        <div>
            <p class="center-align"><i class="material-icons deep-orange-text large">warning</i></p>
            <p class="center-align">{{ mensagemModalConfirm }}</p>
        </div>
    </confirm-dialog>
</template>
<script>
import StHelper from '../../helpers/StHelper';
import TopLoader from '../topLoader/TopLoader.vue';
import ConfirmDialog from "./ConfirmDialog.vue";

export default {
    components: { TopLoader, ConfirmDialog },
    name:'confirm-sim-nao-dialog',
    props: {
        show:{type:Boolean, required:false},
    },
    data() {
        return {
            title: 'Atenção',
            titleWidth: '80%',
            titleTruncate: false,
            confirmLabel: 'Confirmar',
            btnConfirm: true,
            closeOnConfirm: true,
            cancelLabel: 'Cancelar',
            btnCancel: true,
            closeOnCancel: true,
            detail: null,
            width: 'width: 700px;',
            topBottomFixed: false,
            centralizedContent: false,
            centralizedSingleBtn: false,
            switchComponent: false,
            switchOption1: 'Sim',
            switchOption2: 'Não',
            switchInput: false,
            sizeTitle: '24.6px;',
            topLoader: [],
            removeDisplayFlexTitle: false,
            mensagemModalConfirm: 'Tem certeza que deseja confirmar?',
            mostrarModalConfirm: false,
            metodoModalConfirm: () => null,
            fecharModalConfirm: () => null,
        };
    },
    watch:{

    },
    created() {
        this.fecharModalConfirm = () => {
          this.mostrarModalConfirm = false;
          this.mensagemModalConfirm = null;
          this.metodoModalConfirm = null;
          this.fecharModalConfirm = null;
        };
    },
    methods:{
        confirmar() {
            this.metodoModalConfirm();
            this.fechar();
        },
        cancelar() {

        },
        abrir() {
            this.mostrarModalConfirm = true;
        },
        fechar() {
            this.mostrarModalConfirm = false;
        },
        confirmarCancelarEdi(cab) {
            this.metodoModalConfirm = () => {
                this.salvar(cab);
                this.fechar();
            };

            this.mensagemModalConfirm = `Um email foi enviado para o endereço: ${this.selecionado.usuaEmail} com as instruções para recuperar a sua senha.`;
            this.confirmDialogProp.mostrarBtnConfirm = false;
            this.metodoModalConfirm = () => null;

            this.abrir();
        },
    },
    mounted(){
        $(this.$refs.meuConfirm).modal({
            dismissible: false
        });
        StHelper.truncateActive();
    }
}

</script>

<style lang="scss" scoped>

	.top-bottom-fixed {
        width: 70%;
        height: 58vh;
        max-height: 80vh;

        .divider:first-child {
            margin-bottom: 1px;
        }
    }

    .centralized-content {
        display: flex;
        justify-content: center;
        align-items: center;
    }

	@media only screen and (max-width: 600px) {
		.top-bottom-fixed {
            width: 95% !important;
           
            .modal-content{
				height: calc(100% - 97px) !important;
                padding: 1rem;
            }

			.modal-footer{
                padding: 1rem;
            }
		}

		.modal {
		    top: initial;
		    width: 95% !important;
            max-height: 86% !important;
		}

		.text-title {
            font-size: initial !important;
        }
	}
</style>


// WEBPACK FOOTER //
// ConfirmSimNaoDialog.vue?680391cf